module.exports = __webpack_public_path__ + "static/media/img-news1.79423575.jpg";